import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { NotFoundComponent } from './not-found.component';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: 'not-found',
      component: NotFoundComponent,
      data: { title: 'Enroll And Pay' },
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NotFoundRoutingModule {}
